import { pickDay, pickId, pickOne, pickState, searchOf } from '../../lib/searchFilter'
import { EQUIPMENT_TYPES } from '../carriers/api'
import { BOARD_SORTS, BOARD_STATUSES, type AvailabilityFilter } from './api'

/** The board's filters as its address spells them: `?status=HeldBack&state=TX&sort=Carrier`. */
export function boardFilterFrom(search: URLSearchParams): AvailabilityFilter {
  return {
    status: pickOne(search.get('status'), BOARD_STATUSES),
    carrierId: pickId(search.get('carrier')),
    equipment: pickOne(search.get('equipment'), EQUIPMENT_TYPES),
    state: pickState(search.get('state')),
    availableFrom: pickDay(search.get('from')),
    availableTo: pickDay(search.get('to')),
    sort: pickOne(search.get('sort'), BOARD_SORTS),
  }
}

/** The address a filter is written to; the board's own order, soonest available, goes unsaid. */
export function boardSearchFrom(filter: AvailabilityFilter): URLSearchParams {
  return searchOf([
    ['status', filter.status],
    ['carrier', filter.carrierId],
    ['equipment', filter.equipment],
    ['state', filter.state],
    ['from', filter.availableFrom],
    ['to', filter.availableTo],
    ['sort', filter.sort === 'Available' ? undefined : filter.sort],
  ])
}

/** Whether the board shows less than what is current — the sort reorders, it narrows nothing. */
export function isNarrowed(filter: AvailabilityFilter): boolean {
  return [filter.status, filter.carrierId, filter.equipment, filter.state, filter.availableFrom, filter.availableTo].some(
    (value) => value !== undefined,
  )
}
